<script lang="ts">
  import { onMount } from 'svelte';
  import { followUser, unfollowUser, userDetails } from '$src/utils/api/user.util';
  import type { IUser } from 'garden-common';
  import SeedLogo from '$icons/SeedLogo.svelte';
  import TopDonorBadge from '$icons/TopDonorBadgeIcon.svelte';
  import LoaderRows from '$lib/components/common/loaders/LoaderRows.svelte';
  import { selectedPostDetailsTab } from '$src/stores';
  import UserAvatarWrapper from '../common/user/userAvatarWrapper.svelte';
  import Button from '../common/buttons/Button.svelte';

  export let userId: string = '';
  export let donation: any = null;
  // export let gallery: any = null;
  export let loadingIds: string[] = [];
  export let me: any;
  export let showTopDonor: boolean = false;

  let userData: IUser<string> | null = null;

  onMount(async () => {
    if (!userId) return;
    const user = await userDetails(userId);
    if (user) {
      userData = user;
    }
  });

  const handleFollow = async (id: string) => {
    if (loadingIds.includes(id)) return;
    loadingIds = [...loadingIds, id];
    const res = await followUser(id);

    if (res === 'User followed') {
      me.followingUsers = [...me.followingUsers, id];
    }

    loadingIds = loadingIds.filter(i => i != id);
  };

  const handleUnfollow = async (id: string) => {
    if (loadingIds.includes(id)) return;
    loadingIds = [...loadingIds, id];
    const res = await unfollowUser(id);

    if (res === 'User unfollowed') {
      me.followingUsers = me.followingUsers.filter(i => i !== id);
    }

    loadingIds = loadingIds.filter(i => i != id);
  };
</script>

{#if $selectedPostDetailsTab === 'seeds'}
  <div class="w-full flex gap-6 flex-col overflow-auto {donation ? '' : 'mt-6'}">
    <div class="w-full flex items-center">
      <div class="w-fit flex relative p-2">
        {#if showTopDonor}
          <TopDonorBadge />
        {/if}
        <UserAvatarWrapper
          cls={'w-12 aspect-square'}
          profileImage={donation?.donator?.profileImage}
          userName={donation?.donator?.userName}
        />
        <div class="ml-3 text-left">
          <div class="text-blueish-grey-600">
            {donation?.donator?.name ?? donation?.donator?.userName}
          </div>
          <div class="text-color-gray-13 text-sm">@{donation?.donator?.userName}</div>
        </div>
      </div>
      <div class="ml-auto">
        <div class="flex items-center text-blueish-grey-600 gap-2">
          <SeedLogo size={'16px'} />
          <div>{donation?.donationValue} seed{donation?.donationValue > 1 ? 's' : ''}</div>
        </div>
      </div>
    </div>
  </div>
{:else if $selectedPostDetailsTab === 'likes'}
  {#if userData}
    <div class="w-full flex mt-6 gap-6 flex-col overflow-auto">
      <div class="w-full flex">
        <div class="w-fit flex">
          <UserAvatarWrapper
            cls={'w-12 aspect-square'}
            profileImage={userData?.profileImage}
            userName={userData?.userName}
          />
          <div class="ml-3 text-left">
            <div class="text-blueish-grey-600">
              {userData.name ?? userData.userName}
            </div>
            <div class="text-color-gray-13 text-sm">@{userData.userName}</div>
          </div>
        </div>
        <div class="ml-auto">
          {#if !me || userId === me._id}
            <div></div>
          {:else if me.followingUsers.includes(userData._id)}
            <Button
              xs
              secondary
              disabled={loadingIds.includes(userData._id)}
              on:click={() => handleUnfollow(userData._id)}
              cls="hover:!text-red-400 hover:!border-red-400 group hover:!bg-white"
            >
              <div class="block group-hover:hidden px-1">Following</div>
              <div class="hidden group-hover:block px-1">Unfollow</div>
            </Button>
          {:else if userData.followingUsers.includes(me._id) && !me.followingUsers.includes(userData._id)}
            <Button
              xs
              label="Follow Back"
              disabled={loadingIds.includes(userData._id)}
              on:click={() => handleFollow(userData._id)} />
          {:else}
            <Button
              xs
              label="Follow"
              disabled={loadingIds.includes(userData._id)}
              on:click={() => handleFollow(userData._id)} />
          {/if}
        </div>
      </div>
    </div>
  {:else}
    <LoaderRows height={50} rows={1} />
  {/if}
{:else if $selectedPostDetailsTab === 'saves'}
  {#if userData}
    <div class="w-full flex mt-6 gap-6 flex-col overflow-auto">
      <div class="w-full flex">
        <div class="w-fit flex">
          <UserAvatarWrapper
            cls={'w-12 aspect-square'}
            profileImage={userData?.profileImage}
            userName={userData?.userName}
          />
          <div class="ml-3 text-left">
            <div class="text-blueish-grey-600">
              {userData.name ?? userData.userName}
            </div>
            <div class="text-color-gray-13 text-sm">@{userData.userName}</div>
          </div>
        </div>
        <div class="ml-auto">
          {#if !me || userId === me._id}
            <div></div>
          {:else if me.followingUsers.includes(userData._id)}
            <Button
              xs
              border
              secondary
              disabled={loadingIds.includes(userData._id)}
              on:click={() => handleUnfollow(userData._id)}
              cls="hover:!text-red-400 hover:!border-red-400 group hover:!bg-white"
            >
              <div class="block group-hover:hidden px-1">Following</div>
              <div class="hidden group-hover:block px-1">Unfollow</div>
            </Button>
          {:else if userData.followingUsers.includes(me._id) && !me.followingUsers.includes(userData._id)}
            <Button
              xs
              border
              label="Follow Back"
              disabled={loadingIds.includes(userData._id)}
              on:click={() => handleFollow(userData._id)} />
          {:else}
            <Button
              xs
              border
              label="Follow"
              disabled={loadingIds.includes(userData._id)}
              on:click={() => handleFollow(userData._id)} />
          {/if}
        </div>
      </div>
    </div>
  {:else}
    <LoaderRows height={50} rows={1} />
  {/if}
{/if}
